import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[10px] text-sm font-medium transition-[background-color,border-color,color,box-shadow,transform] duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background active:scale-[0.985] disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-black/[0.09] bg-white text-foreground shadow-[0_1px_2px_hsl(30_12%_18%/0.05)] hover:border-black/[0.16] hover:bg-[hsl(40_10%_97.5%)]",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-black/[0.07]",
        soft:
          "bg-black/[0.045] text-foreground hover:bg-black/[0.08]",
        ink:
          "bg-[hsl(var(--ink))] text-white shadow-[0_1px_2px_hsl(0_0%_0%/0.2),0_8px_18px_-10px_hsl(0_0%_0%/0.5)] hover:bg-black",
        ghost: "text-foreground/80 hover:bg-black/[0.05] hover:text-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-[9px] px-3 text-xs",
        lg: "h-11 rounded-xl px-6 text-[15px]",
        xl: "h-12 rounded-xl px-7 text-[15px]",
        icon: "h-9 w-9",
        "icon-sm": "h-8 w-8 rounded-[9px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
